module.exports = __webpack_public_path__ + "img/-LV4ykzzrRfRqIwzEYzW.a10b950a.jpg";